<div class="page-overlay" *ngIf="isBusy">
   <div class="center">
      <mat-spinner color="accent"></mat-spinner>
   </div>
</div>
<div class="main-fab">
   <button mat-fab color="accent" (click)="openAddCscProjectDialog()">
      <mat-icon>add</mat-icon>
   </button>
</div>
<div class="main-page-content">
   <h1>Projekte</h1>
   <mat-form-field style="width: 100%; margin-bottom: 24px;">
      <mat-label>Filter</mat-label>
      <input #searchInput matInput (input)="setProjectsFilter(searchInput.value)" (keyup.escape)="searchInput.value=''; setProjectsFilter(undefined)">
      <button mat-button *ngIf="searchInput.value" matSuffix mat-icon-button aria-label="Clear" (click)="searchInput.value=''; setProjectsFilter(undefined)">
         <mat-icon color="accent">close</mat-icon>
       </button>
   </mat-form-field>
   <div class="cs-project" *ngFor="let cscProject of cscProjects">
      <button mat-button class="cs-project-button" [routerLink]="['/projects', cscProject.id.toString()]" >
         <mat-card>
            <mat-card-header>
               <mat-card-title>{{cscProject.projectName}}</mat-card-title>
               <mat-card-subtitle>
                  {{cscProject.chargingStationAddress.line1}},
                  {{cscProject.chargingStationAddress.postalCode}}
                  {{cscProject.chargingStationAddress.city}}
               </mat-card-subtitle>
            </mat-card-header>
         </mat-card>
      </button>

      <div class="cs-project-action-buttons-container">
         <button class="cs-project-action-button" mat-icon-button color="accent" (click)="copyProject(cscProject.id)">
            <mat-icon>file_copy</mat-icon>
         </button>
         <button class="cs-project-action-button" mat-icon-button color="accent" (click)="openDeletProjectDialog(cscProject)">
            <mat-icon>delete</mat-icon>
         </button>
      </div>
   </div>
 </div>